import KendoChartBase from '../KendoChartBase'
import StockChartProps from './StockChartProps'

import Navigator from './Navigator'

export default {
    props: StockChartProps,
    mixins: [
        KendoChartBase,
        Navigator
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoStockChart(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget: function() {
            return kendo.jQuery(this.$el).getKendoStockChart()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoStockChart/KendoStockChartMixin.js